<template>
  <v-container>
    <form @submit.prevent="submitForm">
      <v-row>
        <!-- Title -->
        <v-col cols="12" md="6">
          <v-select
              label="টাইটেল (নামের পূর্বে)"
              :items="titleBefore"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <v-col cols="12" md="6">
          <v-select
              label="টাইটেল (নামের পরে)"
              :items="titleAfter"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <!-- Name -->
        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              নাম (বাংলা) <span class="text-danger">*</span>
            </label>
            <div class="info-value">মোঃ হোসেন আলী ফয়জুল</div>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              নাম (ইংরেজি) <span class="text-danger">*</span>
            </label>
            <div class="info-value">Md. Hossain Ali Foyzul</div>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              এনআইডি নম্বর (স্মার্ট) <span class="text-danger">*</span>
            </label>
            <div class="info-value">8219860411</div>
          </div>
        </v-col>

        <!-- Smart NID Upload -->
        <v-col cols="12" md="4">
          <v-file-input
              v-model="form.smart_nid_file"
              class="flex-grow-1"
              variant="outlined"
              rounded="lg"
              prepend-icon=""
              hide-details="auto"
              density="comfortable"
              label="এনআইডির কপি (স্মার্ট) আপলোড *"
              accept=".pdf,.jpg,.jpeg,.png"
              hint="সর্বোচ্চ সাইজ ৩ এমবি। ফরমেট : pdf, jpg, jpeg, png"
              persistent-hint
              prepend-inner-icon="mdi-file"
          ></v-file-input>
        </v-col>

        <!-- Old NID -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.old_nid"
              label="এনআইডি নম্বর (পুরাতন)"
              variant="outlined"
              density="comfortable"
              hint="এনআইডি নম্বর ১৩ ডিজিট হলে শুরুতে জন্ম সাল যুক্ত করুন"
              persistent-hint
          ></v-text-field>
        </v-col>

        <!-- Old NID Upload -->
        <v-col cols="12" md="4">
          <v-file-input
              v-model="form.old_nid_file"
              class="flex-grow-1"
              variant="outlined"
              rounded="lg"
              prepend-icon=""
              hide-details="auto"
              density="comfortable"
              label="এনআইডির কপি (পুরাতন) আপলোড *"
              accept=".pdf,.jpg,.jpeg,.png"
              hint="সর্বোচ্চ সাইজ ৩ এমবি। ফরমেট : pdf, jpg, jpeg, png"
              prepend-inner-icon="mdi-file"
              persistent-hint
          ></v-file-input>
        </v-col>

        <!-- DOB -->
        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              জন্মতারিখ <span class="text-danger">*</span>
            </label>
            <div class="info-value">১৩ মার্চ ১৯৯০</div>
          </div>
        </v-col>

        <!-- Gender -->
        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              জেন্ডার <span class="text-danger">*</span>
            </label>
            <div class="info-value">পুরুষ</div>
          </div>
        </v-col>

        <!-- Birth Reg -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.birth_registration"
              label="জন্ম নিবন্ধন নম্বর"
              variant="outlined"
              density="comfortable"
          ></v-text-field>
        </v-col>

        <!-- Birth Reg Upload -->
        <v-col cols="12" md="4">
          <v-file-input
              v-model="form.birth_file"
              class="flex-grow-1"
              variant="outlined"
              rounded="lg"
              prepend-icon=""
              hide-details="auto"
              density="comfortable"
              label="জন্ম নিবন্ধন কপি আপলোড"
              accept=".pdf,.jpg,.jpeg,.png"
              hint="সর্বোচ্চ সাইজ ৩ এমবি। ফরমেট : pdf, jpg, jpeg, png"
              persistent-hint
              prepend-inner-icon="mdi-file"
          ></v-file-input>
        </v-col>

        <!-- Mobile -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.mobile"
              label="মোবাইল নম্বর *"
              variant="outlined"
              density="comfortable"
              prepend-inner-icon="mdi-phone-outline"
          ></v-text-field>
        </v-col>

        <!-- Email -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.email"
              label="ই-মেইল *"
              variant="outlined"
              density="comfortable"
              prepend-inner-icon="mdi-email-outline"
          ></v-text-field>
        </v-col>

        <!-- Religion -->
        <v-col cols="12" md="4">
          <v-select
              v-model="form.religion"
              :items="religions"
              label="ধর্ম *"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <!-- Marital Status -->
        <v-col cols="12" md="4">
          <v-select
              v-model="form.marital_status"
              :items="maritalStatus"
              label="বৈবাহিক অবস্থা *"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <!-- Nationality -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.nationality"
              label="জাতীয়তা"
              variant="outlined"
              density="comfortable"
          ></v-text-field>
        </v-col>

        <!-- District -->
        <v-col cols="12" md="4">
          <v-select
              v-model="form.district"
              :items="districts"
              label="জন্মস্থান (জেলা) *"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <div class="info-block">
            <label class="form-label">
              নিজ জেলা  <span class="text-danger">*</span>
            </label>
            <div class="info-value">নওগাঁ</div>
          </div>
        </v-col>

        <!-- Blood Group -->
        <v-col cols="12" md="4">
          <v-select
              v-model="form.blood_group"
              :items="bloodGroups"
              label="রক্তের গ্রুপ *"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>

        <!-- Height -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.height"
              label="উচ্চতা (সেন্টিমিটার)"
              variant="outlined"
              density="comfortable"
              type="number"
          ></v-text-field>
        </v-col>

        <!-- Identification -->
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.identification_mark"
              label="শনাক্তকরণ চিহ্ন"
              variant="outlined"
              density="comfortable"
          ></v-text-field>
        </v-col>

        <!-- Submit -->
        <v-col cols="12" class="mt-4">
          <v-btn
              color="primary"
              size="large"
              class="me-3 rounded-lg"
              type="submit"
          >
            <v-icon start>mdi-content-save-outline</v-icon>
            সংরক্ষণ করুন
          </v-btn>

          <v-btn
              color="grey-darken-1"
              variant="outlined"
              size="large"
              class="rounded-lg"
              @click="resetForm"
          >
            <v-icon start>mdi-refresh</v-icon>
            রিসেট
          </v-btn>
        </v-col>

      </v-row>
    </form>
  </v-container>
</template>

<script>
export default {
  name: "PersonalComponent",

  data() {
    return {
      titleBefore: ["মোঃ", "মোছাঃ", "ডাঃ", "জনাব"],
      titleAfter: ["পি এইচ ডি", "ইঞ্জিনিয়ার"],

      religions: ["ইসলাম", "হিন্দু", "বৌদ্ধ", "খ্রিস্টান"],
      maritalStatus: ["অবিবাহিত", "বিবাহিত", "তালাকপ্রাপ্ত"],
      districts: ["নওগাঁ", "ঢাকা", "রাজশাহী", "চট্টগ্রাম"],
      bloodGroups: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],

      form: {
        smart_nid_file: null,
        old_nid: "",
        old_nid_file: null,
        birth_registration: "",
        birth_file: null,
        mobile: "",
        email: "",
        religion: null,
        marital_status: null,
        nationality: "বাংলাদেশী",
        district: null,
        blood_group: null,
        height: "",
        identification_mark: "",
      },
    };
  },

  methods: {
    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {
        smart_nid_file: null,
        old_nid: "",
        old_nid_file: null,
        birth_registration: "",
        birth_file: null,
        mobile: "",
        email: "",
        religion: null,
        marital_status: null,
        nationality: "বাংলাদেশী",
        district: null,
        blood_group: null,
        height: "",
        identification_mark: "",
      };
    },
  },
};
</script>

<style scoped>
.form-label {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 4px;
  display: inline-block;
}

.info-value {
  font-size: 20px;
  font-weight: 600;
}
</style>